export const STRIPE_ERROR_CODES_MESSAGE_MAP = {
  invalid_number:
    /* TRANSLATORS: credit card form error message */
    getText('The card number is not a valid credit card number.'),
  invalid_expiry_month:
    /* TRANSLATORS: credit card form error message */
    getText("The card's expiration month is invalid."),
  invalid_expiry_year:
    /* TRANSLATORS: credit card form error message */
    getText("The card's expiration year is invalid."),
  invalid_cvc:
    /* TRANSLATORS: credit card form error message */
    getText("The card's security code is invalid."),
  incorrect_number:
    /* TRANSLATORS: credit card form error message */
    getText('The card number is incorrect.'),
  expired_card:
    /* TRANSLATORS: credit card form error message */
    getText('The card has expired.'),
  incorrect_cvc:
    /* TRANSLATORS: credit card form error message */
    getText("The card's security code is incorrect."),
  incorrect_zip:
    /* TRANSLATORS: credit card form error message */
    getText("The card's zip code failed validation."),
  card_declined:
    /* TRANSLATORS: credit card form error message */
    getText('The card was declined.'),
  missing:
    /* TRANSLATORS: credit card form error message */
    getText('There is no card on a customer that is being charged.'),
  processing_error:
    /* TRANSLATORS: credit card form error message */
    getText('An error occurred while processing the card.'),
  unexpected:
    /* TRANSLATORS: credit card form error message */
    getText('An unexpected error occured.'),
};
